import React, { ChangeEvent } from 'react';
import { ProductAttributeType, ProductStatus } from '@api/graphql/types';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

interface Props {
    name: string;
    value: ProductStatus | null;
    placeholder?: string;
    hint?: string;
    isClearable?: boolean;
    onChangeHandler: (value: ProductAttributeType, name: string) => void;
}

interface State {
    value: ProductStatus | null;
}

class ProductStatusSelect extends React.Component<Props & InjectedIntlProps, State> {

    public state = {
        value: ProductStatus.AVAILABLE,
    };

    public componentDidMount() {
        this.setState({value: this.props.value});
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({value: props.value});
    }

    public render() {
        return (
            <>
                <select
                    name={this.props.name}
                    value={this.state.value || ''}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => { this.props.onChangeHandler((e.currentTarget.value as ProductAttributeType) || null, this.props.name); }}
                    className="form-control"
                >
                    {this.props.isClearable && <option value=''>Összes</option>}
                    {Object.keys(ProductStatus).map((status: string) => (
                        <option key={status} value={ProductStatus[status]}>{this.props.intl.formatMessage({id: `component.ProductStatusSelect.option.${ProductStatus[status]}`})}</option>
                    ))}
                </select>
                {this.props.hint && <span className="form-text m-b-none">{this.props.hint}</span>}
            </>
        );
    }
}

export default compose(
    injectIntl,
)(ProductStatusSelect);



// WEBPACK FOOTER //
// ./src/components/Form/ProductStatusSelect.tsx